import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * ExecutiveGuideBanner — always-visible slim top strip.
 *
 * Sits above the sticky navigation header on every route. Slim (~40px) and
 * consistent across every breakpoint so total sticky-chrome height stays
 * predictable.
 *
 * On mobile (<sm) the guide title is hidden. A compact centred “Executive
 * guide / Download” pairing keeps the strip to one row without truncation. From
 * sm upward the full editorial title becomes visible.
 */
export const ExecutiveGuideBanner = () => (
  <div data-testid="executive-guide-banner" className="bg-ink text-paper border-b border-paper/10">
    <div className="max-w-7xl mx-auto px-6 md:px-10 xl:px-12 h-10 sm:h-11 flex items-center justify-center">
      <Link
        to="/executive-guide"
        data-testid="executive-guide-banner-link"
        aria-label="Executive guide: Is Operational Friction Making Execution Harder Than It Should Be? — Download"
        className="group inline-flex max-w-full min-w-0 items-center justify-center gap-3 sm:gap-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-terra"
      >
        <span className="shrink-0 text-[10px] sm:text-[11px] font-semibold uppercase tracking-[0.22em] text-terra">
          Executive guide
        </span>
        <span className="hidden sm:inline text-paper/25 shrink-0" aria-hidden="true">
          /
        </span>
        <span className="hidden sm:block min-w-0 max-w-[28rem] truncate text-[13px] leading-none text-paper/85">
          Is Operational Friction Making Execution Harder Than It Should Be?
        </span>
        <span className="text-paper/25 shrink-0" aria-hidden="true">
          /
        </span>
        <span className="shrink-0 inline-flex items-center gap-1.5 text-[11px] sm:text-[12px] font-semibold uppercase tracking-[0.16em] text-terra group-hover:text-paper transition-colors duration-300">
          Download
          <ArrowRight
            size={13}
            className="transition-transform duration-300 group-hover:translate-x-1"
          />
        </span>
      </Link>
    </div>
  </div>
);
